import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import { ApiEmpresasService } from '../../shared/services/api-empresas.service';
import { Router } from '@angular/router';
import { AppStorage } from '../../shared/services/appStorage.service';
import { ModalNombreCortoComponent } from './modal-nombre-corto/modal-nombre-corto.component';

@Component({
  selector: 'app-coordinados',
  templateUrl: './coordinados.component.html',
  styleUrls: ['./coordinados.component.css'],
  preserveWhitespaces: true
})
export class CoordinadosComponent implements OnInit {
  displayedColumns: string[] = [
    'nombre_fantasia',
    'sigla',
    'accion_editar',
    'Detalle'
  ];
  dataSource: MatTableDataSource<any>;
  loadingEmpresas;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private apiEmpresas: ApiEmpresasService,
    public dialog: MatDialog,
    public appStorage: AppStorage,
    private router: Router
  ) {}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  details(empresa) {
    this.appStorage.empresa = empresa;
    this.router.navigate(['/admin/coordinados_usuarios']);
  }

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    } else {
      this.getEmpresas();
    }
  }

  public getEmpresas() {
    this.loadingEmpresas = true;
    this.apiEmpresas
      .getEmpresas()
      .then((data: Array<any>) => {
        for (const empresa of data) {
          if (!empresa.sigla) {
            empresa.sigla = '-';
          }
        }

        this.loadingEmpresas = false;
        data.sort((e1, e2) => {
          return e1.nombre_fantasia.localeCompare(e2.nombre_fantasia);
        });
        this.dataSource = new MatTableDataSource(data);

        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
        }, 200);
      })
      .catch(error => {
        this.loadingEmpresas = false;
      });
  }

  openModalNombreCorto(empresa) {
    let data: any = {};
    if (!empresa.sigla || empresa.sigla !== '-') {
      data = {
        icon: 'error_outline',
        empresas: this.dataSource.data,
        texto: 'Es el nombre corto actual, <br/> ¿Desea reemplazarlo?',
        textoBoton: 'Reemplazar',
        callback: (idEmpresa, sigla) => {
          this.appStorage.loadingGeneral = true;
          this.apiEmpresas
            .guardarNombreCorto(idEmpresa, sigla)
            .then(() => {
              this.appStorage.loadingGeneral = false;
              this.getEmpresas();
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      };
    } else {
      data = {
        icon: 'add_circle_outline',
        empresas: this.dataSource.data,
        texto: 'La empresa no posee un nombre corto, <br/> ¿Desea crearlo?',
        textoBoton: 'Crear',
        callback: (idEmpresa, sigla) => {
          this.appStorage.loadingGeneral = true;
          this.apiEmpresas
            .guardarNombreCorto(idEmpresa, sigla)
            .then(() => {
              this.appStorage.loadingGeneral = false;
              this.getEmpresas();
            })
            .catch(error => {
              this.appStorage.loadingGeneral = false;
            });
        }
      };
    }

    data.empresa = empresa;

    const dialogRef = this.dialog.open(ModalNombreCortoComponent, {
      width: '400px',
      data: data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getEmpresas();
      }
    });

    return dialogRef;
  }
}
